import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import "./../styles/statusBar.css";
import { getStepFromStatus } from "./../utils/Miscellaneous";
import TransactionDetailBox from "../components/TransactionDetailBox";
import SubscriptionComponent from "../components/SubscriptionComponent";

// Utility function for grouping transactions by messageGroupId and documentType
const groupTransactionsByMessageGroupIdAndDocumentType = (transactions) => {
  if (!Array.isArray(transactions)) {
    transactions = transactions ? [transactions] : [];
  }
  return transactions.reduce((acc, transaction) => {
    const groupId = transaction.messageGroupId || "default-group"; // Fallback if messageGroupId is undefined
    const documentType = transaction.documentType || "unknown-type"; // Fallback if documentType is undefined

    if (!acc[groupId]) {
      acc[groupId] = {};
    }
    if (!acc[groupId][documentType]) {
      acc[groupId][documentType] = [];
    }
    acc[groupId][documentType].push(transaction);
    return acc;
  }, {});
};

const CustomerTransactions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [subscriptionTransaction, setSubscriptionTransaction] = useState(null);
  const [isSubscribeModalOpen, setLaunchSubscribeModal] = useState(false);
  const [isUnSubscribeModalOpen, setLaunchUnSubscribeModal] = useState(false);

  // State to track the active tab
  const [activeTab, setActiveTab] = useState(null);
  const [visibleTabs, setVisibleTabs] = useState({
    logs: false,
    jira: false,
    email: false,
  });

  const transactions = location.state?.data?.transactionList?.transaction || [];

  // Group transactions by messageGroupId and documentType
  const groupedTransactions =
    groupTransactionsByMessageGroupIdAndDocumentType(transactions);

  // Set the latest transaction that status is not Received and if sent successfully else get processed
  useEffect(() => {
    if (transactions.length > 0) {
      // Find the latest transaction that is not "Received"
      const latestTransaction = transactions
        .filter(
          (transaction) =>
            getStepFromStatus(transaction.boomiStatus) !== "Received"
        ) // Filter out "Received" statuses
        .sort((a, b) => {
          const statusPriority = {
            Received: 1,
            Processing: 2,
            Sent: 3,
            "Received-Error": 1,
            "Translated-Error": 2,
            "Sent-Error": 3,
          };
          // First, sort by the priority of the status
          const statusA =
            statusPriority[getStepFromStatus(a.boomiStatus)] || 99; // Default to low priority if unknown status
          const statusB =
            statusPriority[getStepFromStatus(b.boomiStatus)] || 99;

          if (statusA !== statusB) {
            return statusA - statusB;
          }
        });

      // Try to find a "Sent" transaction first
      const sentTransaction = latestTransaction.find(
        (transaction) => getStepFromStatus(transaction.boomiStatus) === "Sent"
      );

      // If no "Sent" transaction is found, try to find a "Processing" transaction
      const processedTransaction = latestTransaction.find(
        (transaction) =>
          getStepFromStatus(transaction.boomiStatus) === "Processing"
      );

      // Set the current transaction, prioritizing "Sent", then "Processing"
      setSubscriptionTransaction(
        sentTransaction || processedTransaction || latestTransaction[0]
      );
    }
  }, [transactions]);

  console.log("subscription transaction", subscriptionTransaction);

  const handleBackClick = () => {
    if (activeTab) {
      setVisibleTabs((prevState) => ({
        ...prevState,
        [activeTab]: false,
      }));
      setActiveTab(null);
    } else {
      navigate(-1);
    }
  };

  const handleSubscribe = () => setLaunchSubscribeModal(true);
  const handleUnSubscribe = () => setLaunchUnSubscribeModal(true);

  return (
    <div className="content_main">
      {subscriptionTransaction ? (
        <div className="button-container">
          <button className="subscribe-button" onClick={handleSubscribe}>
            Subscribe
          </button>
          <button className="unsubscribe-button" onClick={handleUnSubscribe}>
            Unsubscribe
          </button>
        </div>
      ) : (
        <div style={{ color: "red", fontWeight: "bold" }}>
          Disclaimer: Subscriptions are not available for flows with only
          received transactions.
        </div>
      )}

      <>
        {Object.keys(groupedTransactions).length > 0 ? (
          Object.entries(groupedTransactions).map(
            ([groupId, documentTypes]) => (
              <div key={groupId}>
                <h3>Group: {groupId}</h3>
                {Object.entries(documentTypes).map(
                  ([documentType, transactions]) => (
                    <div key={documentType}>
                      <h4>Document Type: {documentType}</h4>
                      <TransactionDetailBox transactions={transactions} />
                    </div>
                  )
                )}
              </div>
            )
          )
        ) : (
          <p>No transactions available.</p>
        )}
      </>

      <div className="button-container">
        <button className="back-button" onClick={handleBackClick}>
          Back
        </button>
      </div>

      {/* Modal for subscription */}
      <ReactModal
        isOpen={isSubscribeModalOpen}
        contentLabel="Transaction Subscription"
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setLaunchSubscribeModal(false)}
      >
        {subscriptionTransaction && isSubscribeModalOpen ? (
          <SubscriptionComponent
            transaction={subscriptionTransaction}
            actionType={"SUBSCRIBE"}
          />
        ) : (
          <p>Details not available for subscription to be processed</p>
        )}
        <button
          onClick={() => setLaunchSubscribeModal(false)}
          className="close-button"
        >
          Close
        </button>
      </ReactModal>

      {/* Modal for unsubscription */}
      <ReactModal
        isOpen={isUnSubscribeModalOpen}
        contentLabel="Transaction Unsubscription"
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setLaunchUnSubscribeModal(false)}
      >
        {subscriptionTransaction && isUnSubscribeModalOpen ? (
          <SubscriptionComponent
            transaction={subscriptionTransaction}
            actionType={"UNSUBSCRIBE"}
          />
        ) : (
          <p>Details not available for un-subscription to be processed</p>
        )}
        <button
          onClick={() => setLaunchUnSubscribeModal(false)}
          className="close-button"
        >
          Close
        </button>
      </ReactModal>
    </div>
  );
};

export default CustomerTransactions;
